const isMacApp = window.process?.platform === 'darwin'

export const MAC_DESKTOP_HEADER_HEIGHT = isMacApp ? '2.8rem' : '0rem'
export const SET_BADGE = 'SET_BADGE'
